function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Scalar } from '../nodes/Scalar.js';

function resolveBlockScalar(ctx, scalar, onError) {
  var start = scalar.offset;
  var header = parseBlockScalarHeader(scalar, ctx.options.strict, onError);
  if (!header) return {
    value: '',
    type: null,
    comment: '',
    range: [start, start, start]
  };
  var type = header.mode === '>' ? Scalar.BLOCK_FOLDED : Scalar.BLOCK_LITERAL;
  var lines = scalar.source ? splitLines(scalar.source) : []; // determine the end of content & start of chomping

  var chompStart = lines.length;

  for (var i = lines.length - 1; i >= 0; --i) {
    var content = lines[i][1];
    if (content === '' || content === '\r') chompStart = i;else break;
  } // shortcut for empty contents


  if (chompStart === 0) {
    var _value = header.chomp === '+' && lines.length > 0 ? '\n'.repeat(Math.max(1, lines.length - 1)) : '';

    var _end = start + header.length;

    if (scalar.source) _end += scalar.source.length;
    return {
      value: _value,
      type: type,
      comment: header.comment,
      range: [start, _end, _end]
    };
  } // find the indentation level to trim from start


  var trimIndent = scalar.indent + header.indent;
  var offset = scalar.offset + header.length;
  var contentStart = 0;

  for (var _i = 0; _i < chompStart; ++_i) {
    var _lines$_i = _slicedToArray(lines[_i], 2),
        indent = _lines$_i[0],
        _content = _lines$_i[1];

    if (_content === '' || _content === '\r') {
      if (header.indent === 0 && indent.length > trimIndent) trimIndent = indent.length;
    } else {
      if (indent.length < trimIndent) {
        var message = 'Block scalars with more-indented leading empty lines must use an explicit indentation indicator';
        onError(offset + indent.length, 'MISSING_CHAR', message);
      }

      if (header.indent === 0) trimIndent = indent.length;
      contentStart = _i;

      if (trimIndent === 0 && !ctx.atRoot) {
        var _message = 'Block scalar values in collections must be indented';
        onError(offset, 'BAD_INDENT', _message);
      }

      break;
    }

    offset += indent.length + _content.length + 1;
  } // include trailing more-indented empty lines in content


  for (var _i2 = lines.length - 1; _i2 >= chompStart; --_i2) {
    if (lines[_i2][0].length > trimIndent) chompStart = _i2 + 1;
  }

  var value = '';
  var sep = '';
  var prevMoreIndented = false; // leading whitespace is kept intact

  for (var _i3 = 0; _i3 < contentStart; ++_i3) {
    value += lines[_i3][0].slice(trimIndent) + '\n';
  }

  for (var _i4 = contentStart; _i4 < chompStart; ++_i4) {
    var _lines$_i2 = _slicedToArray(lines[_i4], 2),
        _indent = _lines$_i2[0],
        _content2 = _lines$_i2[1];

    offset += _indent.length + _content2.length + 1;
    var crlf = _content2[_content2.length - 1] === '\r';
    if (crlf) _content2 = _content2.slice(0, -1);
    /* istanbul ignore if already caught in lexer */

    if (_content2 && _indent.length < trimIndent) {
      var src = header.indent ? 'explicit indentation indicator' : 'first line';

      var _message2 = "Block scalar lines must not be less indented than their ".concat(src);

      onError(offset - _content2.length - (crlf ? 2 : 1), 'BAD_INDENT', _message2);
      _indent = '';
    }

    if (type === Scalar.BLOCK_LITERAL) {
      value += sep + _indent.slice(trimIndent) + _content2;
      sep = '\n';
    } else if (_indent.length > trimIndent || _content2[0] === '\t') {
      // more-indented content within a folded block
      if (sep === ' ') sep = '\n';else if (!prevMoreIndented && sep === '\n') sep = '\n\n';
      value += sep + _indent.slice(trimIndent) + _content2;
      sep = '\n';
      prevMoreIndented = true;
    } else if (_content2 === '') {
      // empty line
      if (sep === '\n') value += '\n';else sep = '\n';
    } else {
      value += sep + _content2;
      sep = ' ';
      prevMoreIndented = false;
    }
  }

  switch (header.chomp) {
    case '-':
      break;

    case '+':
      for (var _i5 = chompStart; _i5 < lines.length; ++_i5) {
        value += '\n' + lines[_i5][0].slice(trimIndent);
      }

      if (value[value.length - 1] !== '\n') value += '\n';
      break;

    default:
      value += '\n';
  }

  var end = start + header.length + scalar.source.length;
  return {
    value: value,
    type: type,
    comment: header.comment,
    range: [start, end, end]
  };
}

function parseBlockScalarHeader(_ref, strict, onError) {
  var offset = _ref.offset,
      props = _ref.props;

  /* istanbul ignore if should not happen */
  if (props[0].type !== 'block-scalar-header') {
    onError(props[0], 'IMPOSSIBLE', 'Block scalar header not found');
    return null;
  }

  var source = props[0].source;
  var mode = source[0];
  var indent = 0;
  var chomp = '';
  var error = -1;

  for (var i = 1; i < source.length; ++i) {
    var ch = source[i];
    if (!chomp && (ch === '-' || ch === '+')) chomp = ch;else {
      var n = Number(ch);
      if (!indent && n) indent = n;else if (error === -1) error = offset + i;
    }
  }

  if (error !== -1) onError(error, 'UNEXPECTED_TOKEN', "Block scalar header includes extra characters: ".concat(source));
  var hasSpace = false;
  var comment = '';
  var length = source.length;

  for (var _i6 = 1; _i6 < props.length; ++_i6) {
    var token = props[_i6];

    switch (token.type) {
      case 'space':
        hasSpace = true;
      // fallthrough

      case 'newline':
        length += token.source.length;
        break;

      case 'comment':
        if (strict && !hasSpace) {
          var message = 'Comments must be separated from other tokens by white space characters';
          onError(token, 'MISSING_CHAR', message);
        }

        length += token.source.length;
        comment = token.source.substring(1);
        break;

      case 'error':
        onError(token, 'UNEXPECTED_TOKEN', token.message);
        length += token.source.length;
        break;

      /* istanbul ignore next should not happen */

      default:
        {
          var _message3 = "Unexpected token in block scalar header: ".concat(token.type);

          onError(token, 'UNEXPECTED_TOKEN', _message3);
          var ts = token.source;
          if (ts && typeof ts === 'string') length += ts.length;
        }
    }
  }

  return {
    mode: mode,
    indent: indent,
    chomp: chomp,
    comment: comment,
    length: length
  };
}
/** @returns Array of lines split up as `[indent, content]` */


function splitLines(source) {
  var split = source.split(/\n( *)/);
  var first = split[0];
  var m = first.match(/^( *)/);
  var line0 = m !== null && m !== void 0 && m[1] ? [m[1], first.slice(m[1].length)] : ['', first];
  var lines = [line0];

  for (var i = 1; i < split.length; i += 2) {
    lines.push([split[i], split[i + 1]]);
  }

  return lines;
}

export { resolveBlockScalar };